import * as PIXI from "pixi.js";
import { GameData } from "../gamestate/gameData";
import { getParameterByName } from "../../../common/getParameters";
import { createMovieClip } from "../../../common/functions/Functions_General";
import { FireWorksBuilder } from "../fireworks";
import { GameElement } from "../../../common/gameLib/BaseGame/GameElement";
import { BgCloudBonusBookOfTime } from "./bgEffects_cloud";
import { musicSelect } from "../../../common/functions/Function_settingsPage";

// import { BlinkLightArrayBuilder, expandingLight, spotLight } from "./bg_lights";

export class Environment extends GameElement<GameData> {
  // private enableBGanimation: boolean;
  private backGroundCenter: PIXI.Sprite;
  private backGroundCenter2: PIXI.Sprite;
  private bgDesktopToBaseTween: PIXI.tween.Tween;
  private bgDesktopToBonusTween: PIXI.tween.Tween;
  private backGroundLeft: PIXI.Sprite;
  private backGroundRight: PIXI.Sprite;

  private backGroundLeft2: PIXI.Sprite;
  private backGroundRight2: PIXI.Sprite;

  private shockwave: PIXI.Sprite;
  private shockwaveTween: PIXI.tween.Tween;

  private effectsContainer: PIXI.Container = new PIXI.Container();
  private particlesLeftContainer: PIXI.Container = new PIXI.Container();
  private particlesRightContiner: PIXI.Container = new PIXI.Container();

  private bonusBGImageContainer: PIXI.Container = new PIXI.Container();
  // private maxParticlesPerSide: number;
  // private leftParticles: Array<PIXI.Sprite>;
  // private leftParticlesTween: Array<PIXI.tween.Tween>;
  // private rightParticles: Array<PIXI.Sprite>;
  // private rightParticlesTween: Array<PIXI.tween.Tween>;
  // private tissueA: PIXI.extras.AnimatedSprite;
  // private tissueB: PIXI.extras.AnimatedSprite;
  private firework: FireWorksBuilder;
  private demoRibbon: PIXI.Sprite;
  private demoText: PIXI.Text;
  private textDesign: PIXI.TextStyle;
  // private activeGameData: GameData;
  // private parent: PIXI.Container;
  private parentContainer: PIXI.Container;
  private gameBGUI: PIXI.Sprite;
  private gameFramePresent: PIXI.Texture = PIXI.Texture.fromFrame(
    "bgFrameBaseGame.png"
  );
  private gameFramePast: PIXI.Texture = PIXI.Texture.fromFrame("bgFrame.png");
  // private leftEyeFire: PIXI.extras.AnimatedSprite;
  // private rigthtEyeFire: PIXI.extras.AnimatedSprite;
  private glowR: PIXI.Sprite;
  private glowL: PIXI.Sprite;

  private textureNight1: PIXI.Texture;
  private textureNight2: PIXI.Texture;
  private textureNight3: PIXI.Texture;
  private textureDay1: PIXI.Texture;
  private textureDay2: PIXI.Texture;
  private textureDay3: PIXI.Texture;
  private portraitBGimage: PIXI.Sprite;
  private portraitBGimageTexture1: PIXI.Texture;
  private portraitBGimageTexture2: PIXI.Texture;
  private portraitBGimageGradTexture1: PIXI.Texture;
  private portraitBGimageGradTexture2: PIXI.Texture;
  private backgroundLightsContainer: PIXI.Container;
  private fireLeft: PIXI.extras.AnimatedSprite = createMovieClip(
    "fireloop",
    0,
    50
  );

  private fireRight: PIXI.extras.AnimatedSprite = createMovieClip(
    "fireloop",
    0,
    50
  );

  private fireLeftPast: PIXI.extras.AnimatedSprite = createMovieClip(
    "fireloop",
    0,
    50
  );
  private fireRightPast: PIXI.extras.AnimatedSprite = createMovieClip(
    "fireloop",
    0,
    50
  );

  private fx_absorbtionStar: Array<PIXI.Sprite>;
  private fx_absorbtionTweenStar: Array<PIXI.tween.Tween>;

  //-texture portraits

  private textureBotPortraitPast: PIXI.Texture = PIXI.Texture.fromFrame(
    "botPast.png"
  );
  private textureBotPortraitPresent: PIXI.Texture = PIXI.Texture.fromFrame(
    "botPresent.png"
  );
  private textureTopPortraitPast: PIXI.Texture = PIXI.Texture.fromFrame(
    "topPast.png"
  );
  private textureTopPortraitPresent: PIXI.Texture = PIXI.Texture.fromFrame(
    "topPresent.png"
  );
  private gameFramePortraitTop: PIXI.Sprite;
  private gameFramePortraitBot: PIXI.Sprite;

  private fireLeftPortrait: PIXI.extras.AnimatedSprite = createMovieClip(
    "fireloop",
    0,
    50
  );
  private fireRightPortrait: PIXI.extras.AnimatedSprite = createMovieClip(
    "fireloop",
    0,
    50
  );

  private fireRightPortrait2Bonus: PIXI.extras.AnimatedSprite = createMovieClip(
    "fireloop",
    0,
    50
  );
  private fireRightPortrait3Bonus: PIXI.extras.AnimatedSprite = createMovieClip(
    "fireloop",
    0,
    50
  );
  private fireRightPortrait4Bonus: PIXI.extras.AnimatedSprite = createMovieClip(
    "fireloop",
    0,
    50
  );
  private fireLeftPortrait2Bonus: PIXI.extras.AnimatedSprite = createMovieClip(
    "fireloop",
    0,
    50
  );
  private fireLeftPortrait3Bonus: PIXI.extras.AnimatedSprite = createMovieClip(
    "fireloop",
    0,
    50
  );
  private fireLeftPortrait4Bonus: PIXI.extras.AnimatedSprite = createMovieClip(
    "fireloop",
    0,
    50
  );

  private cloudsContainerLeft: PIXI.Container = new PIXI.Container();
  private cloudsContainerRight: PIXI.Container = new PIXI.Container();
    private bonusCloudsLeft:BgCloudBonusBookOfTime;
    private bonusCloudsRight:BgCloudBonusBookOfTime;
     
  constructor(activeGameData: GameData, parent: PIXI.Container) {
    super(activeGameData, parent);

    this.activeGameData = activeGameData;
    // this.enableBGanimation = true; //<--------------ControlsBganimation
    this.parentContainer = parent;
    this.parent = new PIXI.Container();
    parent.addChild(this.parent);

    this.backgroundLightsContainer = new PIXI.Container();
    this.parent.addChild(this.backgroundLightsContainer);

    this.portraitBGimageGradTexture1 = PIXI.Texture.fromImage(
      // "game_BG.png"
      //  "mobileBG0.png"

      "baseGameBGGradientDesktop.png"
    );
    this.portraitBGimageGradTexture2 = PIXI.Texture.fromImage(
      "bonusGameBGGradientDesktop.png"
      // "mobileBG0.png"
    );

    this.portraitBGimageTexture1 = PIXI.Texture.fromImage(
      "bgPresentPortrait.png"
      // "bgPastPortrait.png"
    );
    this.portraitBGimageTexture2 = PIXI.Texture.fromImage("bgPastPortrait.png");

    this.textureNight1 = PIXI.Texture.fromImage("bg_PastEgyptCenter.png");
    this.textureNight2 = PIXI.Texture.fromImage("bg_PastEgyptLeftt.png");
    this.textureNight3 = PIXI.Texture.fromImage("bg_PastEgyptRight.png");
    this.textureDay1 = PIXI.Texture.fromImage("bg_PresentEgyptCenter.png");
    this.textureDay2 = PIXI.Texture.fromImage("bg_PresentEgyptLeft.png");
    this.textureDay3 = PIXI.Texture.fromImage("bg_PresentEgyptRight.png");

    this.backGroundCenter = new PIXI.Sprite(this.textureDay1);

    //-old
    // this.backGroundCenter.anchor.set(0.5, 0);
    // this.backGroundCenter.position.set(this.activeGameData.size[0] / 2, 0);

    this.backGroundCenter.anchor.set(0, 0);
    this.backGroundCenter.position.set(0, 0);
    this.parent.addChild(this.backGroundCenter);

    // this.backGroundCenter.alpha = 1;

    this.backGroundLeft = new PIXI.Sprite(this.textureDay2);
    // this.backGroundLeft.scale.set(1 / 0.96);
    this.backGroundLeft.anchor.set(1, 0);
    this.backGroundLeft.position.set(0, 0);
    this.parent.addChild(this.backGroundLeft);

    this.backGroundRight = new PIXI.Sprite(this.textureDay3);
    // this.backGroundRight.scale.set(1 / 0.96);
    this.backGroundRight.anchor.set(0);
    this.backGroundRight.position.set(this.activeGameData.size[0], 0);
    this.parent.addChild(this.backGroundRight);

    //--bonus game bg

    this.parent.addChild(this.bonusBGImageContainer);

    this.backGroundLeft2 = new PIXI.Sprite(this.textureNight2);
    // this.backGroundLeft.scale.set(1 / 0.96);
    this.backGroundLeft2.anchor.set(1, 0);
    this.backGroundLeft2.position.set(0, 0);
    this.bonusBGImageContainer.addChild(this.backGroundLeft2);

    this.backGroundRight2 = new PIXI.Sprite(this.textureNight3);
    // this.backGroundRight.scale.set(1 / 0.96);
    this.backGroundRight2.anchor.set(0);
    this.backGroundRight2.position.set(this.activeGameData.size[0], 0);
    this.bonusBGImageContainer.addChild(this.backGroundRight2);

    this.backGroundCenter2 = new PIXI.Sprite(this.textureNight1);
    this.backGroundCenter2.anchor.set(0, 0);
    this.backGroundCenter2.position.set(0);
    this.bonusBGImageContainer.addChild(this.backGroundCenter2);
    this.bonusBGImageContainer.alpha = 1;

    this.bgDesktopToBaseTween = PIXI.tweenManager.createTween(
      this.bonusBGImageContainer
    );
    this.bgDesktopToBaseTween.from({ alpha: 1 }).to({ alpha: 0 });
    this.bgDesktopToBaseTween.time = 1500; //get speed from winline animation
    this.bgDesktopToBaseTween.easing = PIXI.tween.Easing.linear();
    this.bgDesktopToBaseTween.loop = false;
    // this.bgDesktopToBaseTween.start();

    this.bgDesktopToBonusTween = PIXI.tweenManager.createTween(
      this.bonusBGImageContainer
    );

    this.bgDesktopToBonusTween.from({ alpha: 0 }).to({ alpha: 1 });
    this.bgDesktopToBonusTween.time = 1500; //get speed from winline animation
    this.bgDesktopToBonusTween.easing = PIXI.tween.Easing.linear();
    this.bgDesktopToBonusTween.loop = false;

    ///-

    this.glowR = new PIXI.Sprite(PIXI.Texture.fromImage("bg_orange.png"));
    this.glowR.tint = 0x0000ff;
    this.glowR.scale.set(8);
    this.glowR.anchor.set(0.5);
    this.glowR.x = 150;
    this.glowR.y = this.activeGameData.size[1];

    this.glowL = new PIXI.Sprite(PIXI.Texture.fromImage("bg_orange.png"));
    this.glowL.scale.set(8);
    this.glowL.anchor.set(0.5);
    this.glowL.tint = 0x0000ff;
    this.glowL.x = this.activeGameData.size[0] - 150;
    this.glowL.y = this.activeGameData.size[1];
    this.glowL.alpha = 1; //0.65;
    this.glowR.alpha = 1; //0.65;

    this.glowR.blendMode = PIXI.BLEND_MODES.SCREEN;
    this.glowL.blendMode = PIXI.BLEND_MODES.SCREEN;

    // this.leftParticles = [];
    // this.leftParticlesTween = [];
    // this.maxParticlesPerSide = 10;
    // this.rightParticles = [];
    // this.rightParticlesTween = [];
    // this.createParticles();

    this.parent.addChild(this.glowL);
    this.parent.addChild(this.glowR);

    this.parent.addChild(this.effectsContainer);
    this.parent.addChild(this.cloudsContainerLeft);
    this.parent.addChild(this.cloudsContainerRight);

    this.effectsContainer.addChild(this.particlesLeftContainer);
    this.effectsContainer.addChild(this.particlesRightContiner);

    //-create insects around light
    let totInsecect = 15;
    let ins = [];
    let ins_R = [];
    for (let i = 0; i < totInsecect; i++) {
      ins[i] = createMovieClip("insect", 0, 500);
      ins[i].loop = true;
      // ins[i].tint=0x88ccaa;
      ins[i].scale.set(1);
      // ins[i].rotation = (Math.random() * 360 * Math.PI) / 180;
      ins[i].blendMode = PIXI.BLEND_MODES.SCREEN;
      ins[i].gotoAndPlay(Math.floor(Math.random() * 500));
      this.particlesLeftContainer.addChild(ins[i]);
      ins[i].x = Math.random() * 150;
      ins[i].y = 700 - Math.random() * 200;

      ins_R[i] = createMovieClip("insect", 0, 500);
      ins_R[i].loop = true;
      // ins[i].tint=0x88ccaa;
      ins_R[i].scale.set(1);
      // ins_R[i].rotation = (Math.random() * 360 * Math.PI) / 180;
      ins_R[i].blendMode = PIXI.BLEND_MODES.SCREEN;
      ins_R[i].gotoAndPlay(Math.floor(Math.random() * 500));
      this.particlesRightContiner.addChild(ins_R[i]);
      ins_R[i].x = this.activeGameData.size[0] - Math.random() * 150 - 150;
      ins_R[i].y = 700 - Math.random() * 200;
    }

    this.firework = new FireWorksBuilder(this.parent, this.activeGameData);
    // this.fireworkR = new FireWorksBuilder(this.parent, this.activeGameData);
    this.textDesign = new PIXI.TextStyle({
      fontFamily: activeGameData.gameTextStyle.gameFont,
      fontSize: 30,
      fill: "#ea9d58",
      fontWeight: "bold",
      lineHeight: 30,
      align: "center",

      dropShadow: true,
      dropShadowColor: "#000000",
      dropShadowBlur: 10,
      dropShadowAngle: Math.PI / 6,
      dropShadowDistance: 0,
      wordWrap:true,
      wordWrapWidth:150
    });

    if (getParameterByName("mode").toLowerCase() == "demo") {
      this.demoRibbon = new PIXI.Sprite(PIXI.Texture.fromImage("demoBG.png"));
      parent.addChild(this.demoRibbon);

      this.demoText = new PIXI.Text(
        this.activeGameData.gameTextGeneral.demo,
        this.textDesign
      );
      this.demoRibbon.addChild(this.demoText);

      this.demoText.anchor.set(0.5);
      this.demoText.x = this.demoRibbon.width / 2;
      this.demoText.y = this.demoRibbon.height / 2;
      this.demoText.width = this.demoRibbon.width - 25;

      this.demoRibbon.x = 12;
      this.demoRibbon.y = 0;

      if (this.activeGameData.isMobile) {
        this.demoRibbon.x = 0;
        this.demoRibbon.y = 125;
        this.demoRibbon.scale.set(0.8);
      }
    }
    this.createAbsorbtion();
    // this.startAbsorbAnimation(true);

    this.createHouseBG();

    if (activeGameData.isMobile && this.activeGameData.playOnPortrait) {
      this.setPortraitBG();
    }

    // this.fireLeft= createMovieClip('fireloop',0,50)
    this.backGroundCenter.addChild(this.fireLeft);
    this.fireLeft.loop = true;
    this.fireLeft.scale.set(1.5);

    this.fireLeft.blendMode = PIXI.BLEND_MODES.ADD;

    // this.fireRight= createMovieClip('fireloop',0,50)
    this.backGroundCenter.addChild(this.fireRight);
    this.fireRight.loop = true;
    this.fireRight.scale.set(1.5);

    this.fireRight.blendMode = PIXI.BLEND_MODES.ADD;

    this.backGroundCenter2.addChild(this.fireRightPast);
    this.backGroundCenter2.addChild(this.fireLeftPast);
    this.fireRightPast.scale.set(1.5);
    this.fireLeftPast.scale.set(1.5);
    this.fireRightPast.blendMode = PIXI.BLEND_MODES.ADD;
    this.fireLeftPast.blendMode = PIXI.BLEND_MODES.ADD;

    this.fireRightPast.y = 550;
    this.fireRightPast.x =
      this.activeGameData.size[0] - this.fireRightPast.width + 20;
    this.fireLeftPast.y = 550;
    this.fireLeftPast.x = -30;

    this.createClouds();
    this.createShockwave();

    this.isBonusGame(false);
  }

  private createClouds = (): void => {
    //---mask for extras effects for bonus game

    let maskBonusLeft = new PIXI.Sprite(PIXI.Texture.fromFrame("maskSky.png"));
    maskBonusLeft.x = -531;

    maskBonusLeft.cacheAsBitmap = true;
    let maskBonusRight = new PIXI.Sprite(PIXI.Texture.fromFrame("maskSky.png"));

    maskBonusRight.scale.x = -1;

    maskBonusRight.x = this.activeGameData.size[0] + 530;

    this.cloudsContainerLeft.addChild(maskBonusLeft);
    this.cloudsContainerRight.addChild(maskBonusRight);


    let maskLeft = new PIXI.Graphics().lineStyle(2, 0xff0000, 1).beginFill(0xff0000)
    // draw a shape
    maskLeft
      .moveTo(-450, 33)
      .lineTo(32, 205)
      .lineTo(32, 230)
      .lineTo(80, 245)
      .lineTo(82, 255)
      .lineTo(85, 260)
      .lineTo(90, 262)
      .lineTo(93, 262)
      .lineTo(110, 280)
      .lineTo(120, 300)
      .lineTo(125, 325)
      .lineTo(118, 330)
      .lineTo(118, 335)
      .lineTo(130, 337)
      .lineTo(100, 550)
      .lineTo(90, 637)
      .lineTo(-405, 637)
      .lineTo(-480, 128)
      .lineTo(-460, 125)
      .lineTo(-455, 118)
      .lineTo(-455, 112)
      .lineTo(-460, 100)
      .lineTo(-470, 93)
      .lineTo(-472, 93)
      .lineTo(-460, 50)
      .endFill();
       maskLeft.scale.set(1);    
    this.cloudsContainerLeft.addChild(maskLeft);



    let maskRight = new PIXI.Graphics().lineStyle(2, 0xff0000, 1).beginFill(0xff0000)
    // draw a shape
    maskRight
      .moveTo(-450, 33)
      .lineTo(32, 205)
      .lineTo(32, 230)
      .lineTo(80, 245)
      .lineTo(82, 255)
      .lineTo(85, 260)
      .lineTo(90, 262)
      .lineTo(93, 262)
      .lineTo(110, 280)
      .lineTo(120, 300)
      .lineTo(125, 325)
      .lineTo(118, 330)
      .lineTo(118, 335)
      .lineTo(130, 337)
      .lineTo(100, 550)
      .lineTo(90, 637)
      .lineTo(-405, 637)
      .lineTo(-480, 128)
      .lineTo(-460, 125)
      .lineTo(-455, 118)
      .lineTo(-455, 112)
      .lineTo(-460, 100)
      .lineTo(-470, 93)
      .lineTo(-472, 93)
      .lineTo(-460, 50)
      .endFill();
      maskRight.scale.set(-1,1);    
      maskRight.x=this.activeGameData.size[0];


    this.cloudsContainerRight.addChild(maskRight);



    //
    // let  blurFilters= new PIXI.filters.BlurFilter() //for antialiasing
    // blurFilters.blur = 30;
    // maskLeft.filters=[blurFilters];
    // maskRight.filters=[blurFilters];
    // this.cloudsContainerRight.mask=maskBonusRight;

    //vector mask for blendmode
    maskLeft.alpha = 0;
    maskRight.alpha = 0;
    this.cloudsContainerLeft.mask=   maskLeft;
    this.cloudsContainerRight.mask=    maskRight ;
    //sprite mask for non blendmod
    maskBonusLeft.alpha = 1;
    maskBonusRight.alpha = 1;
    this.cloudsContainerLeft.mask=   maskBonusLeft;
    this.cloudsContainerRight.mask=    maskBonusRight ;


    this.bonusCloudsLeft= new BgCloudBonusBookOfTime(this.cloudsContainerLeft,20,this.activeGameData.size,false)
 


   this.bonusCloudsRight= new BgCloudBonusBookOfTime(this.cloudsContainerRight,20,this.activeGameData.size,true)
 

    // let totalClouds = 50;
    // let cloudsSprite = [];
    // let cloudTweeen = [];

    // let cloudsSprite_R = [];
    // let cloudTweeen_R = [];


    // for (let i = 0; i < totalClouds; i++) {
    //   cloudsSprite[i] = new PIXI.Sprite(
    //     PIXI.Texture.fromFrame("Cloud.H03lowRes.2k.png")
    //   );
    //   cloudsSprite[i] .blendMode=PIXI.BLEND_MODES.ADD
    //   this.cloudsContainerLeft.addChild(cloudsSprite[i]);
    //   cloudsSprite[i].anchor.set(0.5);
    //   cloudsSprite[i].mask=maskBonusLeft;
    //   cloudsSprite[i].alpha=0;
    //   cloudTweeen[i] = PIXI.tweenManager.createTween(cloudsSprite[i]);
    //   let randScale=Math.random()*4+2;
    //   cloudTweeen[i]
    //     .from({
    //       x: this.activeGameData.size[0]/2,
        
    //       alpha: .5,
    //       y:Math.random()*800,
    //       scale:{x:0,y:0},
    //       rotate: ((Math.random() * 720)-360) * (Math.PI / 180),
    //     })
    //     .to({
    //       x: -500,
    //       y: 0,
    //       alpha: 0,
    //       scale:{x:randScale,y:randScale},
    //       rotation: Math.random() * 360 * (Math.PI / 180),
    //     });
    //   cloudTweeen[i].time = 5000;
    //   cloudTweeen[i].loop = false;
    //   cloudTweeen[i].delay =(1/totalClouds)*cloudTweeen[i].time; // (cloudTweeen[i].time / totalClouds + 1) * i;
    //   cloudTweeen[i].easing = PIXI.tween.Easing.linear();
    //   // cloudTweeen[i].start();   
    // }

    // //-create autoupdate
    // for (let index = 0; index < cloudTweeen.length; index++) {
    //   let nextTween=cloudTweeen[0];
    //   if(cloudTweeen[index+1]!=undefined)
    //   {
    //     nextTween=cloudTweeen[index+1];
    //   }
     
    //   cloudTweeen[index].on('update', function (tween: PIXI.tween.Tween, totalTween:number, elapsedTime: number) {
    //     tween
    //     let startnewDelta=(1/totalTween)*5;
    //     // console.log(startnewDelta,elapsedTime);
    //     if (elapsedTime > startnewDelta){//1/totalTween && tween.active==false) { 
    //       nextTween.reset();
    //       nextTween.delay=0;
    //       nextTween.start();
    //         console.log('start new tween')
    //     }

    // }.bind(cloudTweeen[index], nextTween, cloudTweeen.length));
    // }

    // cloudTweeen[0].start();
  };

  private createShockwave = (): void => {
    this.shockwave = new PIXI.Sprite(PIXI.Texture.fromFrame("ZoomingFx.png"));
    // this.shockwave.tint=(0xff5500)
    this.shockwave.anchor.set(0.5);
    this.shockwave.position.set(
      this.activeGameData.size[0] / 2,
      this.activeGameData.size[1] / 2
    );

    this.parent.addChild(this.shockwave);

    this.shockwave.blendMode = PIXI.BLEND_MODES.ADD;

    this.shockwaveTween = PIXI.tweenManager.createTween(this.shockwave);
    this.shockwaveTween
      .from({ scale: { x: 5, y: 5 }, alpha: 1 })
      .to({ scale: { x: 8, y: 8 }, alpha: 0 });
    this.shockwaveTween.time = 2000;
    this.shockwaveTween.easing = PIXI.tween.Easing.outSine();
    this.shockwaveTween.loop = false;

    // this.shockwaveTween.loop = true;
  };
  public isBonusGame = (bool: boolean): void => {
    if (bool) {
      ///-is bonus game
      this. bonusCloudsRight.Start();
      this.bonusCloudsLeft.Start();
      this.shockwaveTween.start();

      // this.backGroundCenter.texture = this.textureNight1;
      // this.backGroundLeft.texture = this.textureNight2;
      // this.backGroundRight.texture = this.textureNight3;

      this.bgDesktopToBonusTween.start();
      // this.bgDesktopToBaseTween.reset();
      // this.bgDesktopToBaseTween.start();

      this.particlesRightContiner.position.set(-10, -100);
      this.particlesLeftContainer.position.set(-100, -100);

      this.fireRightPast.gotoAndPlay(
        Math.random() * this.fireRightPast.totalFrames
      );
      this.fireLeftPast.gotoAndPlay(
        Math.random() * this.fireLeftPast.totalFrames
      );

      this.fireRight.stop(); //(Math.random() * this.fireRight.totalFrames);
      this.fireLeft.stop(); //(Math.random() * this.fireLeft.totalFrames);

      if (this.gameFramePortraitTop != undefined) {
        this.gameFramePortraitTop.texture = this.textureTopPortraitPast;
        this.gameFramePortraitBot.texture = this.textureBotPortraitPast;

        this.fireRightPortrait.y = -1230;
        this.fireLeftPortrait.y = -1230;
        this.fireRightPortrait.x = this.activeGameData.size[0] - 70;
        this.fireLeftPortrait.x = 70;

        //-enable fire
        this.fireLeftPortrait2Bonus.gotoAndPlay(
          Math.random() * this.fireRightPortrait2Bonus.totalFrames
        );
        this.fireLeftPortrait3Bonus.gotoAndPlay(
          Math.random() * this.fireRightPortrait2Bonus.totalFrames
        );
        this.fireLeftPortrait4Bonus.gotoAndPlay(
          Math.random() * this.fireRightPortrait4Bonus.totalFrames
        );
        this.fireRightPortrait2Bonus.gotoAndPlay(
          Math.random() * this.fireRightPortrait2Bonus.totalFrames
        );
        this.fireRightPortrait3Bonus.gotoAndPlay(
          Math.random() * this.fireRightPortrait2Bonus.totalFrames
        );
        this.fireRightPortrait4Bonus.gotoAndPlay(
          Math.random() * this.fireRightPortrait4Bonus.totalFrames
        );

        this.fireLeftPortrait2Bonus.alpha = 1;
        this.fireLeftPortrait3Bonus.alpha = this.fireLeftPortrait2Bonus.alpha;
        this.fireLeftPortrait4Bonus.alpha = this.fireLeftPortrait3Bonus.alpha;
        this.fireRightPortrait2Bonus.alpha = this.fireLeftPortrait3Bonus.alpha;
        this.fireRightPortrait3Bonus.alpha = this.fireLeftPortrait3Bonus.alpha;
        this.fireRightPortrait4Bonus.alpha = this.fireLeftPortrait3Bonus.alpha;
      }

      this.activeGameData.mainGame.setBonusLeftVisible(true);
      this.activeGameData.background.setNewTexture(
        "bonusGameBGGradientDesktop.png"
      ); //sky desktop

      if (this.activeGameData.isMobile && this.activeGameData.playOnPortrait) {
        this.portraitBGimage.texture = this.portraitBGimageTexture2;
        this.activeGameData.portraitBGSky.texture = this.portraitBGimageGradTexture2;

        // this.ExpandingLightPortrait.setLightOn(true);
      }

      //  this.activeGameData.bonusGameMusic.stop();
      // if (this.activeGameData.bonusGameMusic.playing() == false) {
      //   this.activeGameData.bonusGameMusic.play("bonus");
        // this.activeGameData.normalGameMusic.stop();
      //   // console.log('stop base game music and play bonusmusic');
      // }

            // }
            musicSelect(1,this.activeGameData);
            // console.log('stop base game music and play bonusmusic')

      this.activeGameData.mainGame.setBonusLeftVisible(true);

      this.fireRight.y = 550;
      this.fireRight.x =
        this.activeGameData.size[0] - this.fireRight.width + 20;
      this.fireLeft.y = 550;

      this.fireLeft.x = -30;

      this.gameBGUI.texture = this.gameFramePast;
    } else {
      //is base game
      this.bgDesktopToBonusTween.stop();
      this. bonusCloudsRight.stop();
      this.bonusCloudsLeft.stop();
      this.shockwaveTween.start();
      this.fireRightPast.stop();
      this.fireLeftPast.stop();
      this.fireRight.gotoAndPlay(Math.random() * this.fireRight.totalFrames);
      this.fireLeft.gotoAndPlay(Math.random() * this.fireLeft.totalFrames);

      this.fireRight.y = 610;
      this.fireRight.x = this.activeGameData.size[0] - this.fireRight.width;
      this.fireLeft.y = 670;
      this.fireLeft.x = 50;

      this.activeGameData.mainGame.setBonusLeftVisible(false);

      this.particlesRightContiner.position.set(0, 0);
      this.particlesLeftContainer.position.set(0, 0);

      this.bgDesktopToBaseTween.start();

      this.activeGameData.background.setNewTexture(
        "baseGameBGGradientDesktop.png"
      );

      if (this.activeGameData.isMobile && this.activeGameData.playOnPortrait) {
        this.portraitBGimage.texture = this.portraitBGimageTexture1;
        this.activeGameData.portraitBGSky.texture = this.portraitBGimageGradTexture1;
        // this.ExpandingLightPortrait.setLightOn(false);
      }

      // default gam

      if (this.activeGameData.normalGameMusic.playing() == false) {
        this.activeGameData.normalGameMusic.stop();
        this.activeGameData.normalGameMusic.play("music");
        this.activeGameData.bonusGameMusic.stop();
        // console.log("play")
      }

      this.activeGameData.mainGame.setBonusLeftVisible(false);
      this.gameBGUI.texture = this.gameFramePresent;

      if (this.gameFramePortraitTop != undefined) {
        this.gameFramePortraitTop.texture = this.textureTopPortraitPresent;

        this.gameFramePortraitBot.texture = this.textureBotPortraitPresent;
        this.fireRightPortrait.y = -1150;
        this.fireLeftPortrait.y = -1090;
        this.fireRightPortrait.x = this.activeGameData.size[0] - 100;
        this.fireLeftPortrait.x = 180;

        //-disable fire
        this.fireLeftPortrait2Bonus.stop();
        this.fireLeftPortrait3Bonus.stop();
        this.fireLeftPortrait4Bonus.stop();
        this.fireRightPortrait2Bonus.stop();
        this.fireRightPortrait3Bonus.stop();
        this.fireRightPortrait4Bonus.stop();

        this.fireLeftPortrait2Bonus.alpha = 0;
        this.fireLeftPortrait3Bonus.alpha = this.fireLeftPortrait2Bonus.alpha;
        this.fireLeftPortrait4Bonus.alpha = this.fireLeftPortrait3Bonus.alpha;
        this.fireRightPortrait2Bonus.alpha = this.fireLeftPortrait3Bonus.alpha;
        this.fireRightPortrait3Bonus.alpha = this.fireLeftPortrait3Bonus.alpha;
        this.fireRightPortrait4Bonus.alpha = this.fireLeftPortrait3Bonus.alpha;
      }
    }

    //--buybonus game 
    this.hideBuyBonus(bool);
    //--hide bonus symbol
    this.showBonusSymbolPicked(bool);

  };
  private showBonusSymbolPicked=(bool:boolean):void=>
  {
    let isBonusSpin=this.activeGameData.GameContext().usedInputAction==this.activeGameData.API_handler.getServerActionBonusSpin();
    let isExpanded=this.activeGameData.GameContext().usedInputAction==this.activeGameData.API_handler.getServerActionExpandBookOfTime();
    let isBonusGameStartedPlaying=isBonusSpin||isExpanded?true:false;
    // console.log(bool ,isBonusGameStartedPlaying,'MINIATURE',this.activeGameData.GameContext())
    if(bool && isBonusGameStartedPlaying)
    {
      this.activeGameData.mainGame.getBonusSymbolPickedOverlay().setVisible(true);
  
    }
    else
    {
  
      this.activeGameData.mainGame.getBonusSymbolPickedOverlay().setVisible(false);
    }
    
  }
  private hideBuyBonus=(bool:boolean):void=>
  {
    if(bool)
    { 

      ///in bonus game bg hide the  buy bonus
      if(this.activeGameData.BuyBonus!=undefined )
      {
      
        // activeGameData.BuyBonusIsClientSideReady=false;
        this.activeGameData.BuyBonus.enableBuyBonusIfAllowed(false);
        this.activeGameData.BuyBonus.setHidden(true);
        
      }
    }
    else
    {
      if( this.activeGameData.BuyBonus!=undefined)
      {
        this.activeGameData.BuyBonus.setHidden(false);
        let isAllowedToBuyBonus= this.activeGameData.loginResponse.gameSettings.defaultAllowedInputActions.indexOf(this.activeGameData.API_handler.getServerActionBUY_BONUS())>=0;
        this.activeGameData.BuyBonus.enableBuyBonusIfAllowed(isAllowedToBuyBonus);
 
      }
   

    }
  }
  public checkMusicAndBonusMode = (): void => {
    // console.log("CHECK MUSIC2")
    if (
      // (this.activeGameData.GameContext().bonusGameResult != undefined &&
      //   this.activeGameData.GameContext().finished == false) ||
      this.activeGameData.GameContext().bonus &&
      this.activeGameData.GameContext().finished == false
    ) {
      //--bonus game
      if (this.activeGameData.bonusGameMusic.playing() == false) {
        //   console.log("BONUS MUSIC========================")
        // console.log("NIGHT FIX1ss");
        this.isBonusGame(true);
      }
    } else {
      //-normal gae
      this.isBonusGame(false);
    }
  };

  public checkBonusGameMusic = (): void => {
    // console.log("CHECK MUSIC1")
    let hasBonusSpins =
      this.activeGameData.GameContext().gameRoundBalance.bonusSpins > 0;
    let hasBonusResult =
      this.activeGameData.GameContext().bonusGameResult != undefined &&
      this.activeGameData.GameContext().bonus;
    // console.log("NIGHT FIX1");
    if (hasBonusResult || hasBonusSpins) {
      //--bonus game

      this.isBonusGame(true);
    } else {
      this.isBonusGame(false);
    }
  };

  private setPortraitBG = (): void => {
    let topContainer = this.activeGameData.portraitModeBackground.getTopContainer();

    let botContainer = this.activeGameData.portraitModeBackground.getBotContainer();
    let maxWidth = this.activeGameData.size[0];

    //create lights
    // let lightp1 = new PIXI.Sprite(PIXI.Texture.fromFrame("bgLightTile.png"));
    // lightp1.tint=0xff00ff;
    // lightp1.alpha = 0.25;
    // lightp1.blendMode = PIXI.BLEND_MODES.ADD;
    // lightp1.scale.set(2);
    // lightp1.anchor.set(1);
    // lightp1.y = -1080;
    // lightp1.rotation = Math.PI / 2;
    // lightp1.x = this.activeGameData.size[0] / 2;
    // botContainer.addChild(lightp1);
    // // let lightp2 = new PIXI.Sprite(PIXI.Texture.fromFrame("bgLightTile.png"));
    // // lightp1.tint=0xff00ff;
    // lightp2.alpha = 0.25;
    // lightp2.blendMode = PIXI.BLEND_MODES.ADD;
    // lightp2.scale.set(2, -2);
    // lightp2.anchor.set(1);
    // lightp2.y = -1080;
    // lightp2.rotation = Math.PI / 2;
    // lightp2.x = this.activeGameData.size[0] / 2;
    // botContainer.addChild(lightp2);

    this.gameFramePortraitTop = new PIXI.Sprite(this.textureTopPortraitPresent);
    this.gameFramePortraitTop.width = this.activeGameData.size[0];
    this.gameFramePortraitTop.y = 330;
    this.gameFramePortraitTop.scale.y = this.gameFramePortraitTop.scale.x;
    topContainer.addChild(this.gameFramePortraitTop);
    this.gameFramePortraitBot = new PIXI.Sprite(this.textureBotPortraitPresent);
    this.gameFramePortraitBot.width = this.activeGameData.size[0];
    this.gameFramePortraitBot.y = 1560;
    this.gameFramePortraitBot.scale.y = this.gameFramePortraitBot.scale.x;
    topContainer.addChild(this.gameFramePortraitBot);

    // this.portraitBlinkingTop = new BlinkLightArrayBuilder(
    //   topContainer,
    //   19,
    //   true,
    //   50
    // );
    // this.portraitBlinkingTop.setPosition([60, this.gameFramePortraitBot.y + 40]);
    // this.portraitBlinkingTop.setScale(2);
    // this.portraitBlinkingTop.setVisible(true);

    // this.portraitBlinkingBot = new BlinkLightArrayBuilder(
    //   topContainer,
    //   19,
    //   true,
    //   50
    // );
    // this.portraitBlinkingBot.setPosition([60, this.gameFramePortraitTop.y + 40]);
    // this.portraitBlinkingBot.setScale(2);
    // this.portraitBlinkingBot.setVisible(true);

    // this.ExpandingLightPortrait = new expandingLight(botContainer, true);
    // this.ExpandingLightPortrait.getparent().scale.set(1.5);
    // this.ExpandingLightPortrait.setPosition(
    //   this.activeGameData.size[0] / 2,
    //   -500
    // );
    // this.ExpandingLightPortrait.setRotation(90);
    // this.ExpandingLightPortrait.setLightOn(false);

    // create foregroudn

    this.portraitBGimage = new PIXI.Sprite(this.portraitBGimageTexture1);

    this.portraitBGimage.anchor.set(0.5, 1);
    botContainer.addChild(this.portraitBGimage);
    this.portraitBGimage.x = this.activeGameData.size[0] / 2;
    this.portraitBGimage.scale.set(2.9);
    this.portraitBGimage.y = 0;
    this.portraitBGimage.alpha = 1;

    let glowR = new PIXI.Sprite(PIXI.Texture.fromImage("bg_orange.png"));
    glowR.scale.set(20);
    glowR.anchor.set(0.5);
    glowR.x = maxWidth / 2;
    glowR.y = 0; // this.activeGameData.size[1];
    glowR.blendMode = PIXI.BLEND_MODES.SCREEN;
    glowR.alpha = 0.5;
    botContainer.addChild(glowR);

    let glowTop = new PIXI.Sprite(PIXI.Texture.fromImage("bg_orange.png"));
    glowTop.scale.set(15);
    glowTop.anchor.set(0.5);
    glowTop.x = maxWidth / 2;
    glowTop.y = 900; // this.activeGameData.size[1];
    // glowTop.tint=0x00ffff;
    glowTop.blendMode = PIXI.BLEND_MODES.SCREEN;
    // glowTop.tint=0x0000ff;
    glowTop.alpha = 1;
    topContainer.addChild(glowTop);

    // this.fireLeftPortrait= createMovieClip('fireloop',0,50)
    botContainer.addChild(this.fireLeftPortrait);
    this.fireLeftPortrait.loop = true;
    this.fireLeftPortrait.scale.set(1.5);
    this.fireLeftPortrait.blendMode = PIXI.BLEND_MODES.ADD;
    this.fireLeftPortrait.anchor.set(0.5, 1);
    this.fireLeftPortrait.scale.set(2);

    botContainer.addChild(this.fireRightPortrait);
    this.fireRightPortrait.loop = true;
    this.fireRightPortrait.blendMode = PIXI.BLEND_MODES.ADD;
    this.fireRightPortrait.anchor.set(0.5, 1);
    this.fireRightPortrait.scale.set(2);

    this.fireLeftPortrait.gotoAndPlay(
      Math.random() * this.fireLeftPortrait.totalFrames
    );
    this.fireRightPortrait.gotoAndPlay(
      Math.random() * this.fireLeftPortrait.totalFrames
    );

    // private fireRightPortrait2Bonus:PIXI.extras.AnimatedSprite=createMovieClip('fireloop',0,50);
    // private fireRightPortrait3Bonus:PIXI.extras.AnimatedSprite=createMovieClip('fireloop',0,50);
    // private fireRightPortrait4Bonus:PIXI.extras.AnimatedSprite=createMovieClip('fireloop',0,50);
    // private fireLeftPortrait2Bonus:PIXI.extras.AnimatedSprite=createMovieClip('fireloop',0,50);
    // private fireLeftPortrait3Bonus:PIXI.extras.AnimatedSprite=createMovieClip('fireloop',0,50);
    // private fireLeftPortrait4Bonus:PIXI.extras.AnimatedSprite=createMovieClip('fireloop',0,50);

    //--bonus fires
    botContainer.addChild(this.fireRightPortrait2Bonus);
    botContainer.addChild(this.fireRightPortrait3Bonus);
    botContainer.addChild(this.fireRightPortrait4Bonus);
    botContainer.addChild(this.fireLeftPortrait2Bonus);
    botContainer.addChild(this.fireLeftPortrait3Bonus);
    botContainer.addChild(this.fireLeftPortrait4Bonus);

    //-left
    this.fireLeftPortrait2Bonus.loop = true;
    this.fireLeftPortrait2Bonus.blendMode = PIXI.BLEND_MODES.ADD;
    this.fireLeftPortrait2Bonus.anchor.set(0.5, 1);
    this.fireLeftPortrait2Bonus.scale.set(1);
    this.fireLeftPortrait2Bonus.y = -1350;
    this.fireLeftPortrait2Bonus.x = 390;

    this.fireLeftPortrait3Bonus.loop = true;
    this.fireLeftPortrait3Bonus.blendMode = PIXI.BLEND_MODES.ADD;
    this.fireLeftPortrait3Bonus.anchor.set(0.5, 1);
    this.fireLeftPortrait3Bonus.scale.set(0.7);
    this.fireLeftPortrait3Bonus.y = -1400;
    this.fireLeftPortrait3Bonus.x = 540;

    this.fireLeftPortrait4Bonus.loop = true;
    this.fireLeftPortrait4Bonus.blendMode = PIXI.BLEND_MODES.ADD;
    this.fireLeftPortrait4Bonus.anchor.set(0.5, 1);
    this.fireLeftPortrait4Bonus.scale.set(0.3, 0.3);
    this.fireLeftPortrait4Bonus.y = -1450;
    this.fireLeftPortrait4Bonus.x = 640;

    //-right
    this.fireRightPortrait2Bonus.loop = true;
    this.fireRightPortrait2Bonus.blendMode = PIXI.BLEND_MODES.ADD;
    this.fireRightPortrait2Bonus.anchor.set(0.5, 1);
    this.fireRightPortrait2Bonus.scale.set(1);
    this.fireRightPortrait2Bonus.y = -1350;
    this.fireRightPortrait2Bonus.x = this.activeGameData.size[0] - 390;

    this.fireRightPortrait3Bonus.loop = true;
    this.fireRightPortrait3Bonus.blendMode = PIXI.BLEND_MODES.ADD;
    this.fireRightPortrait3Bonus.anchor.set(0.5, 1);
    this.fireRightPortrait3Bonus.scale.set(0.7);
    this.fireRightPortrait3Bonus.y = -1400;
    this.fireRightPortrait3Bonus.x = this.activeGameData.size[0] - 540;

    this.fireRightPortrait4Bonus.loop = true;
    this.fireRightPortrait4Bonus.blendMode = PIXI.BLEND_MODES.ADD;
    this.fireRightPortrait4Bonus.anchor.set(0.5, 1);
    this.fireRightPortrait4Bonus.scale.set(0.3, 0.3);
    this.fireRightPortrait4Bonus.y = -1450;
    this.fireRightPortrait4Bonus.x = this.activeGameData.size[0] - 640;
  };

  public setFireWorks = (bool: boolean): void => {
    let fireworks = this.firework.getFireWorks();
    let fireWorksLeft = fireworks[0];
    let fireWorksRight = fireworks[1];

    for (let index = 0; index < fireWorksLeft.length; index++) {
      fireWorksLeft[index].setEnable(bool); // bool;
      fireWorksRight[index].setEnable(bool); // = bool;
    }
    this.firework.setOn(bool);
    // this.fireworkR.setOn(bool);
  };

  private createHouseBG = (): void => {
    this.gameBGUI = new PIXI.Sprite(this.gameFramePresent);

    this.gameBGUI.scale.x = 1.14;
    this.gameBGUI.scale.y = 1.13;

    this.parentContainer.addChild(this.gameBGUI); //default Game
    // this.activeGameData.gameScene.addChild(this.gameBGUI);//default Game
    this.gameBGUI.anchor.set(0.5);
    this.gameBGUI.x = this.activeGameData.size[0] / 2;
    this.gameBGUI.y = this.activeGameData.size[1] / 2 - 18;


    
    if(this.activeGameData.isMobile)
    {
      this.gameBGUI.x = this.activeGameData.size[0] / 2;
      this.gameBGUI.y = this.activeGameData.size[1] / 2-18-9 ;
      this.gameBGUI.scale.x = 1.14;
      this.gameBGUI.scale.y = 1.13;
    }
    //--create linesy

    // let lines = [];
    // for (let i = 0; i < 4; i++) {
    //   lines[i] = new PIXI.Sprite(PIXI.Texture.fromImage("separateLine.png"));
    //   lines[i].anchor.set(0.5);
    //   lines[i].scale.x = 0.5;
    //   // lines[i].x=-384+i*257.2;
    //   lines[i].x = -385 + i * 257.2;
    //   // lines[i].x=i*266-266/2
    //   lines[i].blendMode = PIXI.BLEND_MODES.DIFFERENCE;
    //   this.gameBGUI.addChild(lines[i]);
    // }

    //--create side decoration

    //--create side decoration
    // let sidescale = 0.7;
    // let offsetX = 740;
    // let leftdeco = new PIXI.Sprite(PIXI.Texture.fromImage("sideframe2.png"));

    // leftdeco.scale.set(sidescale, sidescale);
    // leftdeco.anchor.set(0.5);
    // leftdeco.position.set(
    //   this.activeGameData.size[0] / 2 - offsetX,
    //   this.activeGameData.size[1] / 2 - 14 + 5
    // );
    // this.parentContainer.addChild(leftdeco);

    // let rightdeco = new PIXI.Sprite(PIXI.Texture.fromImage("sideframe2.png"));
    // rightdeco.scale.set(-leftdeco.scale.x, leftdeco.scale.y);

    // rightdeco.anchor.set(0.5);
    // rightdeco.position.set(
    //   this.activeGameData.size[0] / 2 + offsetX,
    //   leftdeco.y
    // );
    // this.parentContainer.addChild(rightdeco);

    // let botDeco = new PIXI.Sprite(PIXI.Texture.fromImage("sideframe.png"));
    // botDeco.scale.set(1.25);
    // botDeco.rotation = (Math.PI / 2) * 3;
    // botDeco.anchor.set(0.5);
    // botDeco.position.set(this.activeGameData.size[0] / 2, 1050 + 5);
    // // this.parentContainer.addChild(botDeco);

    // let topDeco = new PIXI.Sprite(PIXI.Texture.fromImage("sideframe.png"));
    // topDeco.scale.set(1.25);
    // topDeco.rotation = Math.PI / 2;
    // topDeco.anchor.set(0.5);
    // topDeco.position.set(this.activeGameData.size[0] / 2, 0);

    // let topDeco2 = new PIXI.Sprite(PIXI.Texture.fromImage("sideframe2.png"));
    // topDeco2.scale.set(1.1);
    // topDeco2.rotation = Math.PI / 2;
    // topDeco2.anchor.set(0.5);
    // topDeco2.position.set(this.activeGameData.size[0] / 2, 50);

    // this.parentContainer.addChild(topDeco2);
    // this.parentContainer.addChild(topDeco);

    // let maskLeft = new PIXI.Graphics();

    // maskLeft.beginFill(0xff0000);
    // maskLeft.drawRect(0, 0, 1920, 845);
    // maskLeft.endFill();
    // maskLeft.y = 105;
    // maskLeft.x = 0;
    // maskLeft.alpha = 0.5;
    // leftdeco.mask = maskLeft;
    // rightdeco.mask = maskLeft;
    // this.parentContainer.addChild(maskLeft);

    // this.parentContainer.addChild(this.gameBGUI);

    // let texturename = "drop_black.png";
    // // drop shadow
    // let dropBlack = new PIXI.Sprite(PIXI.Texture.fromFrame(texturename));
    // dropBlack.anchor.set(0.5);
    // dropBlack.scale.set(1);
    // dropBlack.y = -25;
    // leftdeco.addChild(dropBlack);

    // let dropBlackR = new PIXI.Sprite(PIXI.Texture.fromFrame(texturename));
    // dropBlackR.anchor.set(0.5);
    // dropBlackR.scale.set(dropBlack.scale.x);
    // dropBlackR.y = dropBlack.y;
    // rightdeco.addChild(dropBlackR);

    // // drop shadow
    // let dropBlack2 = new PIXI.Sprite(PIXI.Texture.fromFrame(texturename));
    // dropBlack2.anchor.set(0.5);
    // dropBlack2.scale.set(dropBlack.scale.x);
    // dropBlack2.y = dropBlack.y + 380;
    // leftdeco.addChild(dropBlack2);

    // let dropBlackR2 = new PIXI.Sprite(PIXI.Texture.fromFrame(texturename));
    // dropBlackR2.anchor.set(0.5);
    // dropBlackR2.scale.set(dropBlack.scale.x);
    // dropBlackR2.y = dropBlack2.y;
    // rightdeco.addChild(dropBlackR2);

    // // drop shadow
    // let dropBlack3 = new PIXI.Sprite(PIXI.Texture.fromFrame(texturename));
    // dropBlack3.anchor.set(0.5);
    // dropBlack3.scale.set(dropBlack.scale.x);
    // dropBlack3.y = dropBlack.y - 380;
    // leftdeco.addChild(dropBlack3);

    // let dropBlackR3 = new PIXI.Sprite(PIXI.Texture.fromFrame(texturename));
    // dropBlackR3.anchor.set(0.5);
    // dropBlackR3.scale.set(dropBlack.scale.x);
    // dropBlackR3.y = dropBlack3.y;
    // rightdeco.addChild(dropBlackR3);

    // if (this.activeGameData.isMobile) {
    //   this.gameBGUI.position.set(
    //     this.activeGameData.size[0] / 2,
    //     this.activeGameData.size[1] / 2 - 14 - 5
    //   );
    //   botDeco.position.set(this.activeGameData.size[0] / 2, 1050);
    //   topDeco.position.set(this.activeGameData.size[0] / 2, -7);
    // }
  };

  // private createParticles = (): void => {
  //   if (this.activeGameData.isMobile === false) {
  //     for (var i = 0; i < this.maxParticlesPerSide; i++) {
  //       //particles on left corner
  //       this.leftParticles[i] = new PIXI.Sprite(
  //         PIXI.Texture.fromImage("lensFlare_Sparks2.png")
  //       );
  //       this.leftParticles[i].anchor.set(0.5);
  //       // this.leftParticles[i].tint = 0x0088ff;
  //       this.leftParticles[i].x = -0;
  //       // this.leftParticles[i].scale.set(2);
  //       this.leftParticles[i].y = -this.leftParticles[i].height * 0.75;
  //       this.leftParticles[i].rotation = (360 * Math.random() * Math.PI) / 180;
  //       this.parent.addChild(this.leftParticles[i]);
  //       this.leftParticles[i].alpha = 0;
  //       this.leftParticles[i].scale.set(.1);
  //       this.leftParticlesTween[i] = PIXI.tweenManager.createTween(
  //         this.leftParticles[i]
  //       );
  //       this.leftParticlesTween[i]
  //         .from({
  //           x: this.leftParticles[i].x,
  //           y: this.leftParticles[i].y,
  //           alpha: 1,
  //           rotation: (Math.random()*360)*Math.PI //this.leftParticles[i].rotation,
  //         })
  //         .to({
  //           x: this.leftParticles[i].x + (Math.random() * 500 - 250),
  //           y: this.leftParticles[i].y + 1080,
  //           alpha: 0,
  //           rotation:
  //             this.leftParticles[i].rotation + ( Math.PI) *4,
  //         });
  //       this.leftParticlesTween[i].time = 3000;
  //       this.leftParticlesTween[i].delay =
  //         (i * this.leftParticlesTween[i].time) / this.maxParticlesPerSide;
  //       this.leftParticlesTween[i].time =
  //         Math.random() * 3000 + 15000 + i * 1000;

  //       // console.log(this.leftParticlesTween[i].time )
  //       this.leftParticlesTween[i].loop = true;
  //       this.leftParticlesTween[i].easing = PIXI.tween.Easing.linear();

  //       //particles on right corner
  //       this.rightParticles[i] = new PIXI.Sprite(
  //         PIXI.Texture.fromImage("snowParticles.png")
  //       );
  //       this.rightParticles[i].anchor.set(0.5);
  //       this.rightParticles[i].x = this.activeGameData.size[0];
  //       this.rightParticles[i].y = -this.leftParticles[i].height * 0.75;
  //       this.rightParticles[i].rotation = (360 * Math.random() * Math.PI) / 180;
  //       this.parent.addChild(this.rightParticles[i]);
  //       this.rightParticles[i].alpha = 0;

  //       this.rightParticlesTween[i] = PIXI.tweenManager.createTween(
  //         this.rightParticles[i]
  //       );
  //       this.rightParticlesTween[i]
  //         .from({
  //           x: this.rightParticles[i].x,
  //           y: this.rightParticles[i].y,
  //           alpha: 1,
  //           rotation: this.rightParticles[i].rotation,
  //         })
  //         .to({
  //           x: this.rightParticles[i].x + (Math.random() * 500 - 250),
  //           y: this.rightParticles[i].y + 1080,
  //           alpha: 0,
  //           rotation:
  //             this.rightParticles[i].rotation + (Math.random() * Math.PI) / 4,
  //         });
  //       this.rightParticlesTween[i].time = 3000;
  //       this.rightParticlesTween[i].delay =
  //         (i * this.rightParticlesTween[i].time) / this.maxParticlesPerSide;
  //       this.rightParticlesTween[i].time =
  //         Math.random() * 3000 + 15000 + i * 1000;
  //       this.rightParticlesTween[i].loop = true;
  //       this.rightParticlesTween[i].easing = PIXI.tween.Easing.linear();

  //       this.leftParticles[i].blendMode = PIXI.BLEND_MODES.SCREEN;
  //       this.rightParticles[i].blendMode = PIXI.BLEND_MODES.SCREEN;
  //     }

  //     // console.log("particles created")
  //     this.animateParticles();
  //   }
  // };

  // private animateParticles = (): void => {
  //   if (this.enableBGanimation) {
  //     for (var i = 0; i < this.maxParticlesPerSide; i++) {
  //       this.leftParticlesTween[i].start();
  //       this.rightParticlesTween[i].start();
  //     }
  //   } else {
  //     for (var i = 0; i < this.maxParticlesPerSide; i++) {
  //       this.leftParticlesTween[i].stop();
  //       this.rightParticlesTween[i].stop();
  //     }
  //   }
  // };

  // private startAbsorbAnimation = (bool: boolean): void => {
  //   for (let index = 0; index < this.fx_absorbtionStar.length; index++) {
  //     if (bool) {
  //       this.fx_absorbtionTweenStar[index].reset();
  //       // this.fx_absorbtionTweenStar[0].start();
  //     } else {
  //       this.fx_absorbtionTweenStar[index].stop();
  //       this.fx_absorbtionTweenStar[index].reset();
  //       this.fx_absorbtionStar[index].alpha = 0;
  //     }
  //   }
  //   if (bool) {
  //     this.fx_absorbtionTweenStar[0].start();
  //   }
  // };

  private createAbsorbtion = (): void => {
    // 	let speedCloud=15000;
    let speedStars = 15000;
    //     let maxFxCount=2;
    let maxFxCountStars = 20;

    this.fx_absorbtionStar = [];
    this.fx_absorbtionTweenStar = [];

    let starCloudSprite = ["cloudpuff.png"];
    starCloudSprite;
    for (let i = 0; i < maxFxCountStars; i++) {
      let randomIndex = Math.floor(Math.random() * starCloudSprite.length);
      this.fx_absorbtionStar[i] = new PIXI.Sprite(
        PIXI.Texture.fromFrame(starCloudSprite[randomIndex])
      );
      this.fx_absorbtionStar[i].anchor.set(0.5);
      this.fx_absorbtionStar[i].rotation =
        (Math.random() * 360 * Math.PI) / 180;
      if (i % 2) {
        this.fx_absorbtionStar[i].position.set(
          300,
          this.activeGameData.size[1]
        );
      } else {
        this.fx_absorbtionStar[i].position.set(
          this.activeGameData.size[0] - 300,
          this.activeGameData.size[1]
        );
      }

      // this.backgroundLightsContainer.addChild(this.fx_absorbtionStar[i]);

      this.fx_absorbtionStar[i].blendMode = PIXI.BLEND_MODES.ADD;
      // this.fx_absorbtionStar[i].rotation=(Math.random()*360)*Math.PI/180;

      this.fx_absorbtionStar[i].anchor.set(0.5);
      this.fx_absorbtionStar[i].alpha = 0;
      this.fx_absorbtionTweenStar[i] = PIXI.tweenManager.createTween(
        this.fx_absorbtionStar[i]
      );
      this.fx_absorbtionTweenStar[i]
        .from({ scale: { x: 0, y: 0 }, alpha: 1 })
        .to({ scale: { x: 10, y: 10 }, alpha: 0 });
      this.fx_absorbtionTweenStar[i].time = speedStars;
      // if(randomIndex==0)
      // {
      //   this.fx_absorbtionTweenStar[i].time = speedStars/4;
      // }
      // this.fx_absorbtionTween[i].delay =  this.fx_absorbtionTween[i].time*(i*maxFxCount);
      // console.log(this.fx_absorbtionTweenStar[i].delay)
      this.fx_absorbtionTweenStar[i].easing = PIXI.tween.Easing.outExpo();
      this.fx_absorbtionTweenStar[i].loop = false;

      //-
      // this.fx_absorbtionTweenStar[i].loop = true;
      // this.fx_absorbtionTweenStar[i].delay = i/maxFxCountStars;
    }

    let animStartFrequency = 0.01; //(.01//1/maxFxCountStars);
    for (let i = 0; i < this.fx_absorbtionTweenStar.length; i++) {
      if (i < this.fx_absorbtionTweenStar.length - 1) {
        this.fx_absorbtionTweenStar[i].on(
          "update",
          function(tween: PIXI.tween.Tween, elapsedTime: number) {
            if (elapsedTime > animStartFrequency) {
              tween.start();
            }
          }.bind(
            this.fx_absorbtionTweenStar[i],
            this.fx_absorbtionTweenStar[i + 1]
          )
        );
      }

      let lastAnim = this.fx_absorbtionTweenStar.length - 1;
      this.fx_absorbtionTweenStar[lastAnim].on(
        "update",
        function(tween: PIXI.tween.Tween, elapsedTime: number) {
          if (elapsedTime > animStartFrequency) {
            tween.start();
          }
          3;
        }.bind(
          this.fx_absorbtionTweenStar[lastAnim],
          this.fx_absorbtionTweenStar[0]
        )
      );
    }
  };

  public setGlowScale = (newScale: number): void => {
    this.glowL.scale.set(newScale);
    this.glowR.scale.set(newScale);
  };
  public getGlowScale = (): number => {
    return this.glowL.scale.x;
  };
}
